import { Action } from 'redux'
import { isType } from 'ts-action'
import { IUserCertificateReducer } from 'models/UserCertificate'
import { GetUserCertificates, UserCertificatesFetching } from './actions'

const initialState: IUserCertificateReducer = {
  meta: {
    code: 0,
    message: '',
  },
  isFetching: false,
  data: [],
}

export const userCertificatesReducer = (
  state = initialState,
  action: Action,
): IUserCertificateReducer => {
  if (isType(action, GetUserCertificates)) {
    const { payload } = action
    return {
      ...state,
      meta: payload.meta,
      data: payload.data,
    }
  }
  if (isType(action, UserCertificatesFetching)) {
    const { payload } = action
    return {
      ...state,
      isFetching: payload,
    }
  }
  return state
}
